'use client';

import Link from 'next/link';
import { Music } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SidebarChannelSelector } from './SidebarChannelSelector';

interface MobileHeaderProps {
  className?: string;
}

export function MobileHeader({ className }: MobileHeaderProps) {
  return (
    <header
      className={cn(
        'sticky top-0 left-0 right-0 bg-white border-b border-neutral-200',
        'h-14 flex items-center justify-between px-4 z-40',
        className
      )}
    >
      {/* 로고 — 버전 배지는 /admin 페이지로 이동 (모바일에서 채널 셀렉터 가림 방지) */}
      <Link
        href="/dashboard"
        className="flex items-center gap-1.5 text-purple-600 hover:text-purple-700 transition flex-shrink-0"
      >
        <Music className="w-5 h-5" />
        <span className="font-bold text-base text-neutral-900">Auto-Playlist</span>
      </Link>

      {/* 채널 셀렉터 (compact 모드) */}
      <SidebarChannelSelector compact isExpanded className="min-w-0 flex-shrink" />
    </header>
  );
}

export default MobileHeader;
